import queryString from "qs"
import React from "react"
import { Link, withRouter } from "react-router-dom"
import { Button, Icon } from "semantic-ui-react"
import historyStore from "stores/historyStore"
import { observer } from "mobx-react"
import shop from "shop/shop"

@withRouter
@observer
class ProductPath extends React.Component {
  
  render() {
    const { product, path, location, useHistory, chooseCat } = this.props
    const query = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let categories = shop.getCategoryPath( query.category )
    let segment = false
    if ( categories ) {
      segment = categories.pop()
    }
    
    let to = ""
    if ( query.referer ) {
      let title = query.referrerTitle || "Zurück"
      segment = {
        title: translate( title ),
        link : query.referer
      }
      to = query.referer
    }
    let test = shop.getCategoryPath( query.category).pop()
    if ( chooseCat ) {
      segment = shop.getCategoryPath( chooseCat).pop()
    }
    // use the backlink from the category URL
    if ( !segment && product ) {
      segment = shop.getCategoryPath( product.category.map_id ).pop()
    }
    
    if ( useHistory ) {
      if ( historyStore.history.length > 0 ) {
        return <div>
          <Button style={{border: "none", backgroundColor: "#ffffff"}} basic as={Link} to={historyStore.history[ 0 ].link}><Icon
            name="chevron left"/>{`${historyStore.history[ 0 ].content}`}</Button>
        </div>
      }
      return <Button onClick={() => {
      
      }}>{translate( "Zurück" )}</Button>
    }
    
    if ( query.referrer ) {
      return <Button style={{border: "none", backgroundColor: "#ffffff"}} basic as={Link} to={`${query.referrer}`}><Icon
        name="chevron left"/>Suche</Button>
    }
    if ( segment ) {
      // SIMPLE FORWARD WITH QUERY PARAMS INCLUDED
      if ( to ) {
        return <div>
          <Button style={{border: "none", backgroundColor: "#ffffff"}} basic as={Link} to={to}><Icon
            name="chevron left"/>{segment.title}</Button>
        </div>
      }
      return (
        <div>
          
          <Link className="black-50 fw6" style={{border: "none", backgroundColor: "#ffffff"}} basic to={{
            pathname: segment.link,
            search  : queryString.stringify( { sort:  "sort", dir: "asc", ...query } )
          }}>← {translate("zurück zu")} {segment.title}{console.log("SEGMENT:", segment)}</Link>
        </div>
      )
    }
    // if url AND product data fails => get parent category from historyState
    if ( historyStore.history.length > 0 ) {
      return <div>
        <Button style={{border: "none", backgroundColor: "#ffffff"}} basic as={Link} to={historyStore.history[ 0 ].link}><Icon
          name="chevron left"/>{`${historyStore.history[ 0 ].content}`}</Button>
      </div>
    } else {
      return <div>
        {/*<Breadcrumb>*/}
        {/*<Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>*/}
        {/*<Breadcrumb.Divider/>*/}
        {/*{path.length > 1 &&*/}
        {/*<Breadcrumb.Section link as={Link} to={path[ 0 ].link}>{path[ 0 ].title}</Breadcrumb.Section>}*/}
        {/*{path.length > 1 && <Breadcrumb.Divider/>}*/}
        {/*<Breadcrumb.Section active style={{ whiteSpace: "nowrap" }}>{title}</Breadcrumb.Section>*/}
        {/*</Breadcrumb>*/}
        <div>
          <Button style={{border: "none", backgroundColor: "#ffffff"}} basic as={Link} to={path[ 0 ].link}><Icon name="chevron left"/> zurück zur Übersicht</Button>
        </div>
      </div>
    }
  }
}

export default ProductPath



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/ProductPath.js